import React from 'react'
import Text from './Text'

// type ButtonType = 'goodflip_primary' | 'goodflip_secondary' | 'red';

// interface ButtonProps {
//   type: ButtonType;
//   onClick?: () => void;
//   title: string;
//   leftIcon?: React.ReactElement;
//   rightIcon?: React.ReactElement;
//   disabledLeftIcon?: React.ReactElement;
//   disabledRightIcon?: React.ReactElement;
//   disabled?: boolean;
//   loading?: boolean;
//   className?: string;
//   isSubmitButton?: boolean;
// }

const Button = ({
  type,
  onClick = () => {},
  title,
  leftIcon = <></>,
  rightIcon = <></>,
  disabledLeftIcon = <></>,
  disabledRightIcon = <></>,
  disabled = false,
  loading = false,
  className = '',
  isSubmitButton = false,
}) => {
  const isDisabled = disabled
  const defaultMargin = !className.includes('m-') ? 'my-2 mx-4' : ''
  const buttonType = isSubmitButton ? 'submit' : 'button'

  const getBackgroundColor = (isDisabled, type) => {
    if (type === 'red') return 'bg-ERROR-600'
    if (isDisabled)
      return type === 'goodflip_primary'
        ? 'bg-background-brand-disabled-teal'
        : 'bg-gray-400'
    return type === 'goodflip_primary'
      ? 'bg-background-brand-teal'
      : 'bg-white border-border-brand-primary border-[1px]'
  }

  const getDepthColor = (isDisabled, type) => {
    if (type === 'red') return 'bg-ERROR-700'
    if (isDisabled)
      return type === 'goodflip_primary'
        ? 'bg-background-brand-secondary-teal'
        : 'bg-gray-600'
    return type === 'goodflip_primary'
      ? 'bg-foreground-brand-secondary-teal'
      : 'bg-background-brand-disabled-teal border-border-brand-primary border-[1px]'
  }

  const colors = {
    background: getBackgroundColor(isDisabled, type),
    depth: getDepthColor(isDisabled, type),
  }

  const renderIcon = (icon, disabledIcon) =>
    isDisabled && disabledIcon ? disabledIcon : icon

  return (
    <div
      className={`relative flex items-center justify-center ${defaultMargin} ${className}`}
    >
      <span
        className={`absolute inset-0 h-full rounded-2 ${colors.depth} translate-y-3`}
      />

      <button
        onClick={
          !isDisabled
            ? () => {
                setTimeout(() => onClick(), 200)
              }
            : undefined
        }
        className={`relative z-[1px] flex items-center justify-center w-full px-4 py-4 text-white font-semibold rounded-2 shadow-lg transition-transform duration-200 ${
          isDisabled ? 'cursor-not-allowed' : 'active:translate-y-3'
        } ${colors.background}`}
        disabled={isDisabled}
        type={buttonType}
      >
        {loading ? (
          <div
            className={`w-5 h-5 border-4 ${type === 'goodflip_secondary' ? `border-[#199EA5]` : `border-white`} border-b-transparent rounded-full inline-block box-border animate-spin`}
          />
        ) : (
          <div className="flex items-center">
            {renderIcon(leftIcon, disabledLeftIcon) && (
              <span className="mr-2.5 w-5.5 h-5.5 flex items-center justify-center">
                {React.cloneElement(renderIcon(leftIcon, disabledLeftIcon), {
                  width: 22,
                  height: 22,
                })}
              </span>
            )}
            <Text
              tag="p"
              size="large"
              variant="label"
              bold="true"
              className={
                type === 'goodflip_primary' || type === 'red'
                  ? 'text-text-primary-on-brand'
                  : 'text-[#199EA5]'
              }
            >
              {title}
            </Text>
            {renderIcon(rightIcon, disabledRightIcon) && (
              <span className="ml-2.5 w-5.5 h-5.5 flex items-center justify-center">
                {React.cloneElement(renderIcon(rightIcon, disabledRightIcon), {
                  width: 22,
                  height: 22,
                })}
              </span>
            )}
          </div>
        )}
      </button>
    </div>
  )
}

export default Button
